// libraries
import styled from "styled-components";
import { flexSmart } from "@caps-mobile/styled-lib";
import { ToastContainer } from "react-toastify";
import { whenSmallMax } from "~/theme";

export const StyledApp = styled.div`
    ${props => props.theme.globals.globals.app }

    height: 100%;
    width: 100%;

    ${props => `
        background-color: ${props.theme.colors["bg-primary"]["rgba"]};
    `}
`;

export const StyledNavPlusContent = styled.div<{isSmallMax?: boolean}>`
    height: 100%;
    width: 100%;

    ${flexSmart("flex-start center")};

    ${props => props.isSmallMax ? `flex-direction: column;` : ``}
`;

export const StyledContent = styled.div<{panelOpen?: boolean, isSmallMax?: boolean}>`
    height: ${props => props.isSmallMax ? `calc(100% - 82px)` : `100%`};
    width: 100%;
    transition: width .5s ease-out;
`;

export const StyledToastContainer = styled(ToastContainer)`
  ${props => {
    return`
      --toastify-toast-width: 375px;

      .Toastify__toast {
        background-color: ${props.theme.colors["input-background"]["rgba"]} !important;
        color: ${props.theme.colors["text-primary"]["rgba"]} !important;
        border-radius: 8px;
        font-size: 16px;
        width: 275px;

        ${whenSmallMax(`margin-top: 10px;`)}
      }

      .Toastify__toast--success .Toastify__toast-icon svg {
        background-color:${props.theme.colors["input-background"]["rgba"]} !important;
        fill: ${props.theme.colors["primary"]["rgba"]} !important;
        color: ${props.theme.colors["primary"]["rgba"]} !important;
      }

      .Toastify__toast--success .Toastify__progress-bar {
        background: ${props.theme.colors["primary"]["rgba"]} !important;
      }

      .Toastify__toast--error .Toastify__toast-icon svg {
        background-color: ${props.theme.colors["input-background"]["rgba"]} !important;
        fill: ${props.theme.colors["algo-red"]["rgba"]} !important;
        color: ${props.theme.colors["algo-red"]["rgba"]} !important;
      }

      .Toastify__toast--error .Toastify__progress-bar {
        background: ${props.theme.colors["algo-red"]["rgba"]} !important;
      }

       .Toastify__close-button {
        color: ${props.theme.colors["text-primary"]["rgba"]} !important;
        opacity: 1 !important; /* Ensure visibility */
      }

      .Toastify__close-button:hover {
        color: ${props.theme.colors["bg-secondary"]["rgba"]} !important;
      }

      .Toastify__spinner {
        border-top-color: ${props.theme.colors["text-primary"]["rgba"]} !important;
        border-right-color: ${props.theme.colors["text-primary"]["rgba"]} !important;
        border-bottom-color: transparent !important; /* Creates a spinning effect */
        border-left-color: transparent !important;
      }

      .toast-error {
        background-color: ${props.theme.colors["algo-red"]["rgba"]} !important;
        color: rgba(255,255,255, 0.75) !important;

        .Toastify__toast-icon svg {
          background-color: ${props.theme.colors["algo-red"]["rgba"]} !important;
          fill: rgba(255,255,255, 0.75) !important;
          color: rgba(255,255,255, 0.75) !important;
        }

        .Toastify__close-button {
          color: rgba(255,255,255, 0.75) !important;
          opacity: 1 !important; /* Ensure visibility */
        }
      }

      .Toastify__toast-container--top-center {
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: auto !important;
      }
  `}}
`;